import { render, staticRenderFns } from "./FormType6.vue?vue&type=template&id=698550e7&"
import script from "./FormType6.vue?vue&type=script&lang=js&"
export * from "./FormType6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports